import { Box } from '@mui/material'
import React from 'react'
import Styles from '../Config/Styles'

const Leftimg = () => {
    return (
        <Box sx={Styles.LeftimgStyle.box}>
            <img src={require("../assets/image 1.png")} />
        </Box>
    )
}

export default Leftimg